import { create } from 'zustand';

interface DashboardTitleState {
  /** Titles read from dashboard files already loaded by a view, by fileId. */
  titles: Record<string, string>;
  setTitle: (fileId: string, title: string) => void;
  /** Ordinals of agent dashboards in the loaded messages, by fileId; for versions saved without one. */
  versions: Record<string, number>;
  setVersions: (versions: Record<string, number>) => void;
}

export const useDashboardTitleStore = create<DashboardTitleState>((set) => ({
  titles: {},
  setTitle: (fileId, title) =>
    set((state) =>
      state.titles[fileId] === title ? state : { titles: { ...state.titles, [fileId]: title } }
    ),
  versions: {},
  setVersions: (versions) =>
    set((state) =>
      Object.entries(versions).every(([fileId, version]) => state.versions[fileId] === version)
        ? state
        : { versions: { ...state.versions, ...versions } }
    ),
}));
